
const _ = require('lodash');

const util = require('util');

const vb = require('./definition');

const {
	unwrap,
	ignoreSpaces,
} = require('./util');

const VIN_VALIDATION_MESSAGE = 'введите корректный VIN-номер';
const PIN_VALIDATION_MESSAGE = 'введите корректный PIN-номер';
const REG_NUMBER_VALIDATION_MESSAGE = 'введите корректный гос. номер';
const BODY_ID_VALIDATION_MESSAGE = 'введите корректный номер кузова';
const CHASSIS_ID_VALIDATION_MESSAGE = 'введите корректный номер шасси';
const FRAME_ID_VALIDATION_MESSAGE = 'введите корректный номер рамы';
const BLOCKED_VALUES = ['нд', 'нет данных', 'отсутствует', 'нет', 'no', 'nodata', 'бн',
	'без номера', 'ну', 'не установлен', ',', '!', '»', ';', '%', ':', '?', '_', '+', '=', '\\',
	'/', '$', '^', '&', '`', '~', '’', '|', '*', '@', 'отс', 'otc', '0тс', '0tc', 'отs', 'ots',
	'0ts', 'net', 'ny', 'незап', 'nd', 'na', 'Nа', '«', ' ', '.', '-', '#', '№', '>', '<', '{',
	'}', '[', ']', '«'];

const BLOCKED_BODY_AND_CHASSIS_VALUES = [
	'no', 'nodata', '0tc', 'otc', '0тс', 'оtc', 'отs', 'ots',
	'0ts', 'net', 'ny', 'nd', 'na', 'Na',
];
const VEHICLE_CUSTOM_NAME = 'введите корректную марку/модель';
const TECHNICAL_INSPECTION_MESSAGE = 'введите корректную диагностическую карту';

const PERSON_NAME_VALIDATION_MESSAGES = [
	'введите кириллицей или латиницей',
	'только кириллица или латиница',
	'введите корректное имя',
	'исправьте',
];

const PERSON_NAME_VALIDATOR = v => !v || /(^[a-z A-Z`'-]*$)|(^[ёа-я ЁА-Я`'-]*$)/.test(v);
const EXTENDED_PERSON_NAME_VALIDATOR = v => !v
	|| /(^[a-z A-Z`'-]*$)|(^[ёа-я ЁА-Я`'-]*$)|(^[\u00C0-\u017Fa-zA-Z\s`'-]*$)/.test(v);

const TRACTOR_LICENSE_SERIES_VALIDATION_MESSAGES = [
	'введите корректную серию удостоверения тракториста-машиниста',
	'введите корректную серию УТМ',
	'исправьте серию',
];

const TRACTOR_LICENSE_NUMBER_VALIDATION_MESSAGES = [
	'введите корректный номер удостоверения тракториста-машиниста',
	'введите корректный номер УТМ',
	'исправьте номер',
];

vb.nameRussian = (message) => {
	return {
		validator: (v) => !v || /^[-ЁА-Яёа-я ]*$/.test(v),
		message: message || 'введите кириллицей',
	};
};

vb.nameLatin = (message) => {
	return {
		validator: (v) => !v || /^[-a-zA-Z ]*$/.test(v),
		message: message || 'введите латиницей',
	};
};

vb.nameCyrillicAndLatin = () => {
	return {
		validator: (v) => !v || /^[a-zA-Zёа-яЁА-Я- ]*$/.test(v),
		message: PERSON_NAME_VALIDATION_MESSAGES,
	};
};

vb.nameCyrillicAndLatinWithSymbols = () => {
	return {
		validator: v => !v || /^[a-zA-Zёа-яЁА-Я`'-]*$/.test(v),
		message: PERSON_NAME_VALIDATION_MESSAGES,
	};
};

vb.nameCyrillicOrLatin = () => {
	return {
		validator: (v) => !v || /(^[a-zA-Z- ]*$)|(^[ёа-яЁА-Я- ]*$)/.test(v),
		message: PERSON_NAME_VALIDATION_MESSAGES,
	};
};

vb.nameCyrillicOrLatinWithNumbers = (message) => {
	return {
		validator: (v) => !v || /(^[a-zA-Z0-9]*$)|(^[ёа-яЁА-Я0-9]*$)/.test(v),
		message: message || PERSON_NAME_VALIDATION_MESSAGES,
	};
};

vb.nameCyrillicOrLatinWithSymbols = (message) => {
	return {
		validator: PERSON_NAME_VALIDATOR,
		message: message || PERSON_NAME_VALIDATION_MESSAGES,
	};
};

vb.nameExtendedLatinOrCyrillicOrWithSymbols = (message) => {
	return {
		validator: EXTENDED_PERSON_NAME_VALIDATOR,
		message: message || PERSON_NAME_VALIDATION_MESSAGES,
	};
};

vb.nameCyrillicWithSymbols = () => {
	return {
		validator: v => !v || /^[ёа-яЁА-Я\s`'-]*$/.test(v),
		message: 'только кириллица',
	};
};

vb.nameLatinWithSymbols = () => {
	return {
		validator: v => !v || /(^[a-zA-Z\s`'-]*$)|(^[\u00C0-\u017Fa-zA-Z\s`'-]*$)/i.test(v),
		message: 'только латиница',
	};
};

vb.sameCharsetFullName = (fullName, message) => {
	return {
		validator: () => PERSON_NAME_VALIDATOR(fullName()),
		message: message || PERSON_NAME_VALIDATION_MESSAGES,
	};
};

vb.extendedSameCharsetFullName = (fullName, message) => {
	return {
		validator: () => EXTENDED_PERSON_NAME_VALIDATOR(fullName()),
		message: message || PERSON_NAME_VALIDATION_MESSAGES,
	};
};

vb.passportRussian = () => {
	return {
		validator: (v) => !v || /^\d{4} ?\d{6}$/.test(v),
		message: [
			'введите корректные серию и номер паспорта',
			'исправьте паспорт',
			'исправьте',
		],
	};
};

vb.militaryPassport = () => {
	return {
		validator: (v) => !v || /^[\dA-ZА-Я]{2} ?\d{6,7}$/.test(v),
		message: [
			'введите корректные серию и номер',
			'исправьте',
		],
	};
};

vb.seamanPassport = () => {
	return {
		validator: (v) => !v || /^(([А-ЯЁ03]{2})|([ABEKMHOPCTYX0]{2})) \d{6,7}$/.test(v),
		message: [
			'введите корректные серию и номер',
			'исправьте паспорт',
			'исправьте',
		],
	};
};

vb.diplomaticPassport = () => {
	return {
		validator: (v) => !v || /^[\d]{2} ?\d{7}$/.test(v),
		message: [
			'введите корректные серию и номер',
			'исправьте паспорт',
			'исправьте',
		],
	};
};

vb.refugeeID = () => {
	return {
		validator: (v) => !v || /^(((([A-z0-9]{1,2})|([А-яЁё0-9]{1,2}))\s)?([0-9]{1,12}))$/.test(v),
		message: [
			'введите корректные серию и номер',
			'исправьте',
		],
	};
};

vb.temporaryID = () => {
	return {
		// eslint-disable-next-line max-len
		validator: (v) => !v || /^(((([A-z0-9]{1,10})|([А-яЁё0-9]{1,10}))\s[0-9]{1,12})|([0-9]{1,12}))$/.test(v),
		message: [
			'введите корректные серию и номер',
			'исправьте',
		],
	};
};

vb.foreignPassport = () => {
	return {
		validator: (v) => !v || /^(((([\dA-z-]{1,8})|([\dА-яЁё-]){1,8}) )?([\d]{1,10}))$/.test(v),
		message: () => [
			'введите корректные серию и номер',
			'исправьте',
		],
	};
};

vb.birthCertificate = () => {
	return {
		validator: (v) => !v || /^[А-ЯЁ013ABEKMHOPCTYXIV-]{4,9} [0-9]{6}$/.test(v),
		message: [
			'введите корректные серию и номер',
			'исправьте, пожалуйста',
			'исправьте',
		],
	};
};


vb.residencePermit = () => {
	return {
		validator: (v) => !v || /^[А-ЯЁ0-9I-]{2,6} [0-9]{5,7}$/.test(v),
		message: () => [
			'введите корректные серию и номер',
			'исправьте, пожалуйста',
			'исправьте',
		],
	};
};

vb.travelPassport = () => {
	return {
		validator: (v) => !v || /^\d{2} \d{7}$/.test(v),
		message: () => [
			'введите корректные серию и номер',
			'исправьте, пожалуйста',
			'исправьте',
		],
	};
};

vb.anotherPassport = () => {
	return {
		validator: (v) => !v || /^[a-zA-Zа-яёА-ЯЁ0-9]{1,12} [a-zA-Zа-яёА-ЯЁ0-9]{1,12}$/.test(v),
		message: [
			'введите корректные серию и номер документа',
			'введите корректные серию и номер',
			'исправьте, пожалуйста',
			'исправьте',
		],
	};
};

vb.passportShouldContainAtLeastOneWhitespace = () => {
	return {
		validator: (v) => !v || /^.* .*$/.test(v),
		message: [
			'введите через пробел',
			'исправьте',
		],
	};
};

vb.passportShouldContainOnlyOneWhitespace = () => {
	return {
		validator: (v) => !v || /^\S* {1}\S*$/.test(v),
		message: [
			'превышено количество пробелов в серии и номере',
			'превышено количество пробелов',
			'исправьте',
		],
	};
};

vb.passportShouldContainLimitedSymbols = () => {
	return {
		validator: (v) => !v || /^\S{0,10} \S{0,10}$/.test(v),
		message: [
			'превышено количество символов в номере или серии документа',
			'превышено количество символов',
			'исправьте',
		],
	};
};

vb.driverLicenseRussian = () => {
	return {
		validator: (v) => !v || /^\d{2}([\d]{2}|[A-ZА-Я]{2}) ?\d{6}$/.test(v),
		message: [
			'введите корректные серию и номер водительского удостоверения',
			'введите корректные серию и номер ВУ',
			'введите корректное ВУ',
			'исправьте ВУ',
		],
	};
};

vb.driverLicenseSeriesForeign = () => {
	return {
		validator: (v) => !v || /^[A-яёЁ0-9]{1,40}$/i.test(v),
		message: [
			'введите корректную серию водительского удостоверения',
			'введите корректную серию ВУ',
			'исправьте серию',
		],
	};
};

vb.driverLicenseNumberForeign = () => {
	return {
		validator: (v) => !v || /^[A-яёЁ0-9]{1,40}$/i.test(v),
		message: [
			'введите корректный номер водительского удостоверения',
			'введите корректный номер ВУ',
			'исправьте номер',
		],
	};
};

vb.driverLicenseSeriesCrimean = () => {
	return {
		validator: (v) => !v || /^[А-ЯЁA-Z0-9]+$/i.test(v),
		message: [
			'введите корректную серию водительского удостоверения',
			'введите корректную серию ВУ',
			'исправьте серию',
		],
	};
};

vb.driverLicenseNumberCrimean = () => {
	return {
		validator: (v) => !v || /^[А-ЯЁA-Z0-9]+$/i.test(v),
		message: [
			'введите корректный номер водительского удостоверения',
			'введите корректный номер ВУ',
			'исправьте номер',
		],
	};
};

vb.includeSpaceBetweenSeriesAndNumber = () => {
	return {
		validator: (v) => !v || /^(\S+)\s(\S+)$/i.test(v),
		message: 'введите пробел между серией и номером',
	};
};

vb.includeSpaceBetweenSeriesAndAnyNumber = () => {
	return {
		validator: (v) => !v || /^(\S+)\s(\S+)/i.test(v),
		message: 'введите пробел между серией и номером',
	};
};

vb.tractorDriverLicenseSeries = () => {
	return {
		validator: (v) => !v || /^[А-ЯABEKMHOPCTYX03]{2}$/i.test(v),
		message: TRACTOR_LICENSE_SERIES_VALIDATION_MESSAGES,
	};
};

vb.tractorDriverLicenseSeriesExtended = () => {
	return {
		validator: (v) => !v || /^[a-z-A-Z-А-яЁё]{4}$/i.test(v),
		message: TRACTOR_LICENSE_SERIES_VALIDATION_MESSAGES,
	};
};

vb.tractorDriverLicenseNumber = () => {
	return {
		validator: (v) => !v || /^[0-9]{6}$/i.test(v),
		message: TRACTOR_LICENSE_NUMBER_VALIDATION_MESSAGES,
	};
};

vb.tractorDriverLicense = () => {
	return {
		validator: (v) => !v || /^[А-ЯABEKMHOPCTYX03]{2} [0-9]{6}$/i.test(v),
		message: [
			'введите корректные серию и номер водительского удостоверения',
			'введите корректные серию и номер ВУ',
			'введите корректное ВУ',
			'исправьте ВУ',
		],
	};
};

vb.technicalInspectionNumber = () => {
	return {
		validator: (v) => !v || /^[0-9]+$/ig.test(v),
		message: [
			TECHNICAL_INSPECTION_MESSAGE,
		],
	};
};

vb.tractorTechnicalInspection = () => {
	return _.extend(vb.regex(/^[ёЁА-я]{2}[\s][0-9]{6}$/i), {
		message: () => TECHNICAL_INSPECTION_MESSAGE,
	});
};

vb.notOnlyZero = () => {
	return {
		validator: (v) => !v || !/^0+$/i.test(v.replace(' ', '')),
		message: [
			'поле не может состоять только из нолей',
			'исправьте',
		],
	};
};

vb.notOnlyZeroSeriesOrNumber = () => {
	return {
		validator: (v) => !v || (!/(^[0]+[\s])/gi.test(v) && !/([\s][0]+$)/gi.test(v)),
		message: [
			'Серия и/или номер не может состоять только из 0',
			'исправьте',
		],
	};
};

vb.osagoVin = (message = VIN_VALIDATION_MESSAGE) => {
	return {
		validator: v => !v || (!/[IOQ]+/gi.test(v) && /^[a-z\d]+$/gi.test(v)),
		message: () => [ message ],
	};
};

vb.rsaPin = () => {
	return _.extend(vb.regex(/^[a-zA-Zа-яёА-ЯЁ0-9]{1,100}$/i), {
		message: () => PIN_VALIDATION_MESSAGE,
	});
};

vb.regNumber = () => {
	return {
		validator: v => !v || /^[АВЕКМНОРСТУХABEKMHOPCTYX\d]+$/i.test(v),
		message: () => [ REG_NUMBER_VALIDATION_MESSAGE ],
	};
};

vb.diplomaticRegNumber = () => {
	return {
		validator: v => !v || /^[CDT\d]+$/i.test(v),
		message: () => ['Только латиница'],
	};
};

vb.tractorRegNumber = () => {
	return {
		validator: v => !v
			// eslint-disable-next-line max-len
			|| /^(([0-9]{4}([АВЕКМНОРСТУХABEKMHOPCTYX]{2,3}|[АВЕКМНОРСТУХABEKMHOPCTYX]{2}[0-9]{2}))|([АВЕКМНОРСТУХABEKMHOPCTYX]{2}([0-9]{4}|[0-9]{6})))$/i.test(v),
		message: () => [ REG_NUMBER_VALIDATION_MESSAGE ],
	};
};

vb.diplomaticTypeARegNumber = (message) => {
	return {
		validator: v => !v || /^[CDT][0-9]{7}$/i.test(v),
		message: () => message || [ REG_NUMBER_VALIDATION_MESSAGE ],
	};
};

vb.diplomaticTypeBCDRegNumber = (message) => {
	return {
		validator: v => !v || /^([0-9]{3}[CDT][0-9]{5})|([CDT]{2}[0-9]{3}[CDT][0-9]{2})$/i.test(v),
		message: () => message || [ REG_NUMBER_VALIDATION_MESSAGE ],
	};
};

vb.transitTypeBCDRegNumber = (message) => {
	return {
		validator: v => !v || /^[АВЕКМНОРСТУХABEKMHOPCTYX]{3}[0-9]{5}$/i.test(v),
		message: () => message || [ REG_NUMBER_VALIDATION_MESSAGE ],
	};
};

vb.typeAVehicleRegNumber = () => {
	return {
		// 9999AA99, AA99AA99, AA999999, 9999A99, A999AA99, AAA99999, AA9999, 9999AAA
		// eslint-disable-next-line max-len
		validator: v => !v || /^((\d{4}[АВЕКМНОРСТУХABEKMHOPCTYX]{2}\d{2})|([АВЕКМНОРСТУХABEKMHOPCTYX]{2}\d{2}[АВЕКМНОРСТУХABEKMHOPCTYX]{2}\d{2})|([АВЕКМНОРСТУХABEKMHOPCTYX]{2}\d{6})|(\d{4}[АВЕКМНОРСТУХABEKMHOPCTYX]\d{2})|([АВЕКМНОРСТУХABEKMHOPCTYX]\d{3}[АВЕКМНОРСТУХABEKMHOPCTYX]{2}\d{2})|([АВЕКМНОРСТУХABEKMHOPCTYX]{3}\d{5})|([АВЕКМНОРСТУХABEKMHOPCTYX]{2}\d{4})|(\d{4}[АВЕКМНОРСТУХABEKMHOPCTYX]{3}))$/i.test(v),
		message: () => [ REG_NUMBER_VALIDATION_MESSAGE ],
	};
};

vb.regRussianNumber = () => {
	return _.extend(vb.regex(/^[АВЕКМНОРСТУХ0-9\s]{0,9}[0-9]{1}$/i), {
		message: () => REG_NUMBER_VALIDATION_MESSAGE,
	});
};

vb.regEuropeNumber = () => {
	return _.extend(vb.regex(/^[A-Z0-9\s\-]{1,15}$/i), {
		message: () => REG_NUMBER_VALIDATION_MESSAGE,
	});
};

vb.policyNumberOsago = () => {
	return _.extend(vb.regex(/^\d{10}$/i), {
		message: () => 'Укажите корректный номер полиса',
	});
};

vb.osagoVehicleBodyNumber = () => {
	return {
		validator: v => !v || /^[0-9a-zA-Z-]{1,50}$/gi.test(v),
		message: () => [ BODY_ID_VALIDATION_MESSAGE ],
	};
};

vb.osagoVehicleChassisID = () => {
	return {
		validator: v => !v || /^[0-9a-zA-Z/\s-]+$/gi.test(v),
		message: () => [ CHASSIS_ID_VALIDATION_MESSAGE ],
	};
};

vb.rsaVehicleDocumentStrictSeries = () => {
	return _.extend(vb.custom((v) => {
		return !v || v.trim().match(/^[\S]+/)[0].length === 4;
	}), {
		message: () => 'Введите корректную серию',
	});
};

vb.tractorCertificateSeries = () => {
	return _.extend(vb.custom((v) => {
		return !v
			|| ( v.trim().match(/^[\S]+/)[0].length <= 4
				&& v.trim().match(/^[\S]+/)[0].length >= 2
			);
	}), {
		message: () => 'Введите корректную серию',
	});
};

vb.tractorPassportSeries = () => {
	return _.extend(vb.custom((v) => {
		return !v
			|| ( v.trim().match(/^[\S]+/)[0].length <= 4
				&& v.trim().match(/^[\S]+/)[0].length >= 2
			);
	}), {
		message: () => 'Введите корректную серию',
	});
};

vb.rsaVehicleDocumentStrictNumber = () => {
	return _.extend(vb.custom((v) => {
		return !v || v.trim().match(/[\S]+$/)[0].length === 6;
	}), {
		message: () => 'Введите корректный номер',
	});
};

vb.rsaVehicleDocumentStrict = () => {
	return _.extend(vb.regex(/^[a-zA-Zа-яёА-ЯЁ0-9]{4}[\s][0-9]{6}$/i), {
		message: () => 'Введите корректные серию и номер',
	});
};

vb.rsaTractorPassport = () => {
	return _.extend(vb.regex(
		/^([А-Яа-яЁё0-9]{2,4}|[ABEKMHOPCTYX0-9]{2,4})[\s][0-9]{6}$/i
	), { message: () => 'Введите корректные серию и номер' }
	);
};

vb.rsaVehiclePassport = () => {
	return _.extend(vb.regex(/^[0-9]{2}([АВЕКМНОРСТУХЛ0]{2}|([ABEKMHOPCTYX0]{2}))[\s][0-9]{6}$/i), {
		message: () => 'Введите корректные серию и номер',
	});
};

vb.rsaVehicleCertificate = () => {
	return _.extend(vb.regex(/^(([АВЕКМНОРСТУХ0-9]{4})|([ABEKMHOPCTYX0-9]{4}))[\s][0-9]{6}$/i), {
		message: () => 'Введите корректные серию и номер',
	});
};

vb.rsaVehicleDocumentSeries = () => {
	return _.extend(vb.custom((v) => {
		return !v || v.trim().match(/^[\S]+/)[0].length <= 10;
	}), {
		message: () => 'Введите корректную серию',
	});
};

vb.rsaVehicleDocumentNumber = () => {
	return _.extend(vb.custom((v) => {
		return !v || v.trim().match(/[\S]+$/)[0].length <= 40;
	}), {
		message: () => 'Введите корректный номер',
	});
};

vb.rsaVehicleDocument = () => {
	return vb.all([
		vb.regex(/^[a-zA-Zа-яёА-ЯЁ0-9]{1,40}[\s][a-zA-Zа-яёА-ЯЁ0-9]{1,50}$/i,
		'Введите корректные серию и номер',
		),
		vb.notOnlyZero(),
	]);
};

vb.tractorCertificate = () => {
	return vb.all([
		vb.regex(/^[А-Яа-яЁё0-9]{2,4} [0-9]{6}$/i,
			'Введите корректные серию и номер',
		),
		vb.notOnlyZero(),
	]);
};

vb.vehicleCustomModelName = () => {
	return {
		validator: v => !v || /^[a-zA-Zа-яёА-ЯЁ0-9&*.,+?"@'!\/()\s-]+$/gi.test(v),
		message: () => [ VEHICLE_CUSTOM_NAME ],
	};
};

vb.kaskoVin = () => {
	return _.extend(vb.regex(/^[A-HJ-NPR-Z\d]{17}$/i), {
		message: () => VIN_VALIDATION_MESSAGE,
	});
};

vb.commonVin = () => {
	return _.extend(vb.regex(/^[A-HJ-NPR-Z\d]{10,17}$/i), {
		message: () => VIN_VALIDATION_MESSAGE,
	});
};

// ФТ ОСАГО+НГС 3.8
// Буквы латинского алфавита, за исключением I, O, Q и числа от 0 до 9. До 15 символов.
// RGSSUP-2021 - максимальная длина 24 символа
vb.vehicleBodyID = () => {
	return _.extend(vb.regex(/^[A-HJ-NPR-Z\d]{0,24}$/i), {
		message: () => BODY_ID_VALIDATION_MESSAGE,
	});
};

// RGSSUP-2021 - максимальная длина 24 символа
vb.vehicleChassisID = () => {
	return _.extend(vb.regex(/^[A-HJ-NPR-Z\d]{0,24}$/i), {
		message: () => CHASSIS_ID_VALIDATION_MESSAGE,
	});
};

vb.vehicleFrameID = () => {
	return _.extend(vb.regex(/^[A-HJ-NPR-Z\d]{0,24}$/i), {
		message: () => FRAME_ID_VALIDATION_MESSAGE,
	});
};

vb.blockedVehicleIDValues = () => {
	return {
		validator: (v) => v ? !_.includes(BLOCKED_VALUES, v.toLowerCase()) : !v,
		message: ['заполнено неверно'],
	};
};

vb.blockedChassisAndBodyValues = () => {
	return {
		validator: (v) => v ? !_.includes(BLOCKED_BODY_AND_CHASSIS_VALUES, v.toLowerCase()) : !v,
		message: ['заполнено неверно'],
	};
};

vb.vehicleCertificate = () => {
	return _.extend(vb.regex(/^(\d{4}|\d{2}[A-HJ-NPR-ZА-ЯЁ]{2}|[A-HJ-NPR-ZА-ЯЁ]{2,3})\d{6}$/i), {
		message: () => 'введите корректный номер СТС',
	});
};

vb.kaskoVehiclePassport = () => {
	return _.extend(vb.regex(/^\d{2}[А-ЯЁ]{2}\d{6}$/i), {
		message: () => 'введите корректный номер ПТС',
	});
};

vb.vehicleElectronicPassport = () => {
	const message = [
		'Введите ровно 15 цифр',
		'Ровно 15 цифр',
	];
	return vb.all([
		vb.custom(v => !v || _.trim(v, ' _').length === 15,
			() => message),
		vb.regex(/^[1-3][0-9]{3}0[1-4][0-9]{9}$/i),
		vb.digitsOnly(message),
	]);
};

vb.phone11Digits = () => {
	return _.extend(vb.custom((v) => {
		return !v || v.replace(/\D/g, '').length === 11;
	}), {
		message: () => ['введите корректный номер телефона', 'исправьте'],
	});
};

vb.phone10Digits = () => {
	return _.extend(vb.custom((v) => {
		return !v || v.replace(/\D/g, '').length === 10;
	}), {
		message: () => ['введите корректный номер телефона', 'исправьте'],
	});
};

vb.lengthMin = (minAccessor, message) => {
	return {
		validator: (v) => {
			const min = unwrap(minAccessor);
			return !v || (v.length >= min);
		},
		message: () => {
			const min = unwrap(minAccessor);
			const msg = message || util.format('не короче %s символов', min);
			return ['исправьте', msg];
		},
	};
};

vb.lengthMax = (maxAccessor, message) => {
	return {
		validator: (v) => {
			const max = unwrap(maxAccessor);
			return !v || (v.length <= max);
		},
		message: () => {
			const max = unwrap(maxAccessor);
			const msg = message || util.format('не длиннее %s символов', max);
			return ['исправьте', msg];
		},
	};
};

vb.length = (lengthAccessor, message) => {
	return vb.all([
		vb.lengthMax(lengthAccessor, message),
		vb.lengthMin(lengthAccessor, message),
	]);
};

vb.lengthMinIgnoringSpaces = (minAccessor) => {
	return {
		validator: (v) => {
			const min = unwrap(minAccessor);
			return !v || (v.replace(/\s+/g, '').length >= min);
		},
		message: () => {
			const min = unwrap(minAccessor);
			return util.format('не короче %s символов', min);
		},
	};
};

vb.lengthMaxIgnoringSpaces = (maxAccessor) => {
	return {
		validator: (v) => {
			const max = unwrap(maxAccessor);
			return !v || (v.replace(/\s+/g, '').length <= max);
		},
		message: () => {
			const max = unwrap(maxAccessor);
			return util.format('не длиннее %s символов', max);
		},
	};
};

vb.regex = (regexAccessor, message) => {
	return vb.custom((v) => !v || unwrap(regexAccessor).test(v), message);
};

const notConsecutiveSymbolValidator = (consecutiveRegExp, passportNumberRegExp) => {
	return {
		validator: (v) => {
			const [ consecutiveNumbers ] = v.match(consecutiveRegExp) || [];
			const [ passportNumber ] = v.match(passportNumberRegExp) || [];

			return !v || !(consecutiveNumbers && passportNumber
				&& (consecutiveNumbers === passportNumber));
		},
		message: () => [ 'введите корректный номер' ],
	};
};

vb.notConsecutivePassportNumber = () => {
	const consecutiveRegExp = /(?:(?=12|23|34|45|56|67|78|89)\d)+\d$/;
	const passportNumberRegExp = /[0-9]+$/gi;

	return notConsecutiveSymbolValidator(consecutiveRegExp, passportNumberRegExp);
};

vb.notConsecutive6DigitsPassportNumber = () => {
	const consecutiveRegExp = /123456*$/;
	const passportNumberRegExp = /[0-9]+$/gi;

	return notConsecutiveSymbolValidator(consecutiveRegExp, passportNumberRegExp);
};

vb.notConsecutive7DigitsPassportNumber = () => {
	const consecutiveRegExp = /1234567*$/;
	const passportNumberRegExp = /[0-9]+$/gi;

	return notConsecutiveSymbolValidator(consecutiveRegExp, passportNumberRegExp);
};

vb.consecutiveCharRepetitionLimit = (maxCharsAccessor) => {
	return vb.custom((v) => {
		if (!v) {
			return true;
		}

		const maxConsecutiveChars = unwrap(maxCharsAccessor);

		v = String(v).toLowerCase();
		v = v.replace(/\s+/g, '');

		const sameCharGroups = _.reduce(v, function (groups, char) {
			const lastGroup = _.last(groups);
			const lastGroupChar = _.head(lastGroup);
			if (char === lastGroupChar) {
				groups[groups.length - 1] = lastGroup + char;
			} else {
				groups.push(char);
			}
			return groups;
		}, []); // "Mississippi" -> ["M","i","ss","i","ss","i","pp","i"]

		const sameCharCounts = _.map(sameCharGroups, 'length');

		return _.max(sameCharCounts) <= maxConsecutiveChars;
	},
	() => [
		`Не более ${unwrap(maxCharsAccessor) || ''} одинаковых символов подряд`,
		`Не более ${unwrap(maxCharsAccessor) || ''} символов подряд`,
		`исправьте`,
	]);
};

vb.digitsOnly = (message) => _.extend(vb.regex(/^\d*$/), {
	message: () => message || 'только цифры',
});

vb.inn = () => vb.map(ignoreSpaces, vb.all([
	vb.length(10),
	vb.digitsOnly(),
]));

vb.ipInn = () => vb.map(ignoreSpaces, vb.all([
	vb.minLength(10),
	vb.maxLength(12),
	vb.digitsOnly(),
]));

vb.physicalInn = () => {
	const message = [
		'введите корректный ИНН',
		'исправьте',
	];
	return vb.all([
		vb.length(12, message),
		vb.digitsOnly(message),
		vb.custom(v => {
			const isCorrectChecksum = inn => {
				const applyCoefficients = coefficients => {
					let n = 0;
					for (const i in coefficients) {
						n += coefficients[i] * inn[i];
					}
					return parseInt(n % 11 % 10);
				};

				const n11 = applyCoefficients([7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
				const n12 = applyCoefficients([3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);

				return (n11 === parseInt(inn[10])) && (n12 === parseInt(inn[11]));
			};
			return !v || isCorrectChecksum(v);
		}, () => message),
	]);
};

vb.businessRegistrationCertificate = () => vb.map(ignoreSpaces, vb.all([
	vb.length(11, 'Введите 11 цифр'),
	vb.digitsOnly(),
]));

vb.juridicalOrganizationName = () => {
	return {
		validator: v => !v || /^[ёа-яЁА-Я\d/()\s№,.+'`-]+$/i.test(v),
		message: () => [ 'введите корректное наименование' ],
	};
};

vb.hasNotNumberSymbol = (message) => vb.custom(v => !/№/.test(v),
	() => message || ['Не нужно вводить символ «№» перед номером', 'Символ «№» не нужен']);

vb.notRgsEmail = () => {
	return {
		validator: v => !v
			|| !/^.*(@((rgs[.]ru)|(.*[.]rgs[.]ru)|(rgs[.]life)|(agent-rgs[.]ru)))$/i.test(v),
		message: () => [ 'кроме email РГС' ],
	};
};

vb.serviceStationName = (message) => {
	return {
		validator: v => !v || /^[ёа-яЁА-Я\d/()\s№,.'`-]+$/i.test(v),
		message: () => message || [ 'введите корректное наименование' ],
	};
};

vb.notLatinSymbols = (message) => {
	return {
		validator: v => !v || !/^[A-z]+$/i.test(v),
		message: () => message || [ 'Только кириллица' ],
	};
};

vb.isMoreThan0 = (message) => {
	return {
		validator: v => !v || typeof v === 'number' ? v > 0 : parseInt(v) > 0,
		message: () => message || [ 'Выберите' ],
	};
};

vb.isValidUrl = (message) => {
	return {
		validator: v => !v || /^https:\/\/[a-zA-Z0-9\-\.]+(?:\:[0-9]+)?(\/[^\s]*)?$/.test(v),
		message: () => message || [ 'Проверьте корректность' ],
	};
};
